module.exports = __webpack_public_path__ + "img/kehuqianyi.931593e8.png";